import { render } from "./SidebarLeft.vue?vue&type=template&id=ff032bb6&ts=true"
import script from "./SidebarLeft.vue?vue&type=script&lang=ts"
export * from "./SidebarLeft.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__